import React, { useEffect, useState } from "react";
import {
  Badge,
  Box,
  Button,
  Flex,
  Input,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
  useToast,
} from "@chakra-ui/react";
import { RepeatIcon } from "@chakra-ui/icons";
import { useHistory } from "react-router-dom";
import Card from "components/Card/Card";
import CardHeader from "components/Card/CardHeader";
import CardBody from "components/Card/CardBody";
import ProductApi from "api/product";
import Pagination from "components/Pagination/Pagination";

const SharedAccounts = () => {
  const [products, setProducts] = useState([]);
  const [isLoadingProducts, setIsLoadingProducts] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [nameFilter, setNameFilter] = useState("");
  const [maxWorderIdFilter, setMaxWorderIdFilter] = useState("");
  const textColor = useColorModeValue("gray.700", "white");
  const toast = useToast();
  const history = useHistory();

  useEffect(() => {
    fetchSharedProducts(currentPage);
  }, [currentPage, nameFilter, maxWorderIdFilter]);

  const fetchSharedProducts = async (page = 1) => {
    setIsLoadingProducts(true);
    try {
      const params = { page };
      if (nameFilter.trim()) params.name = nameFilter.trim();
      if (maxWorderIdFilter.trim()) params.max_worder_id = maxWorderIdFilter.trim();

      const response = await ProductApi.SharedProducts(params);
      const payload = response?.data;
      const list = Array.isArray(payload?.data) ? payload.data : Array.isArray(payload) ? payload : [];
      setProducts(list);
      setTotalPages(payload?.meta?.last_page || 1);
      setTotalCount(payload?.meta?.total || list.length || 0);
      setPerPage(payload?.meta?.per_page || list.length || 10);
    } catch (error) {
      toast({
        title: "خطا در دریافت محصولات قابل اشتراک",
        description: error?.response?.data?.message || "اتصال به سرور برقرار نشد.",
        status: "error",
        duration: 3500,
        isClosable: true,
        position: "top-right",
      });
    } finally {
      setIsLoadingProducts(false);
    }
  };

  const handleNameFilter = (e) => {
    setNameFilter(e.target.value);
    setCurrentPage(1);
  };

  const handleMaxWorderIdFilter = (e) => {
    setMaxWorderIdFilter(e.target.value.replace(/[^\d]/g, ""));
    setCurrentPage(1);
  };

  return (
    <Flex direction="column" pt={{ base: "120px", md: "75px" }} gap={6} w="100%">
      <Card overflowX={{ sm: "scroll", xl: "hidden" }} w="100%">
        <CardHeader p="6px 0px 22px 0px" display="flex" alignItems="center" justifyContent="space-between" flexWrap="wrap" gap={3}>
          <Flex alignItems="center" gap={3} flexWrap="wrap">
            <Text fontSize="xl" color={textColor} fontWeight="bold">
              محصولات قابل اشتراک
            </Text>
            <Badge colorScheme="purple">تعداد: {totalCount}</Badge>
            <Input
              maxW="220px"
              placeholder="نام محصول (name)"
              value={nameFilter}
              onChange={handleNameFilter}
              textAlign="left"
            />
            <Input
              maxW="220px"
              placeholder="حداکثر شماره سفارش"
              value={maxWorderIdFilter}
              onChange={handleMaxWorderIdFilter}
              textAlign="left"
              inputMode="numeric"
            />
          </Flex>
          <Button leftIcon={<RepeatIcon />} onClick={() => fetchSharedProducts(currentPage)} isLoading={isLoadingProducts} size="sm">
            بروزرسانی
          </Button>
        </CardHeader>
        <CardBody w="100%">
          <Box overflowX="auto" w="100%">
            <Table variant="simple" color={textColor} minWidth="760px" w="100%">
              <Thead>
                <Tr color="gray.400">
                  <Th color="gray.400">ردیف</Th>
                  <Th color="gray.400">نام محصول</Th>
                  <Th color="gray.400">SKU</Th>
                  <Th color="gray.400">عملیات</Th>
                </Tr>
              </Thead>
              <Tbody>
                {products.map((product, index) => (
                  <Tr key={product.id ?? product.name}>
                    <Td>{(currentPage - 1) * perPage + index + 1}</Td>
                    <Td>{product.name ?? "-"}</Td>
                    <Td>{product.sku ?? "-"}</Td>
                    <Td>
                      <Button
                        size="sm"
                        colorScheme="blue"
                        whiteSpace="nowrap"
                        onClick={() =>
                          history.push(
                            `/admin/accounts/shared/${product.id}${
                              maxWorderIdFilter ? `?max_worder_id=${maxWorderIdFilter}` : ""
                            }`
                          )
                        }
                      >
                        نمایش اکانت ها
                      </Button>
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </Box>
          {!isLoadingProducts && products.length === 0 && (
            <Box mt={4}>
              <Text color="gray.500">محصول قابل اشتراکی یافت نشد.</Text>
            </Box>
          )}
        </CardBody>
      </Card>

      <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={setCurrentPage} />
    </Flex>
  );
};

export default SharedAccounts;
